import React from 'react';

/** http(s)-URLs im Text in klickbare Links umwandeln (kein HTML/Markdown). */
const URL_RE = /(https?:\/\/[^\s<>"')\]]+)/gi;

function trimTrailingPunctuation(url: string): { href: string; trailing: string } {
    let href = url;
    let trailing = '';
    while (/[.,;:!?)]$/.test(href)) {
        trailing = href.slice(-1) + trailing;
        href = href.slice(0, -1);
    }
    return { href, trailing };
}

export function LinkifiedText({
    text,
    className,
}: {
    text?: string | null;
    className?: string;
}): React.ReactElement | null {
    const raw = String(text || '');
    if (!raw.trim()) return null;

    const parts = raw.split(URL_RE);
    return (
        <span className={className} style={{ whiteSpace: 'pre-wrap' }}>
            {parts.map((part, i) => {
                if (/^https?:\/\//i.test(part)) {
                    const { href, trailing } = trimTrailingPunctuation(part);
                    return (
                        <React.Fragment key={i}>
                            <a
                                href={href}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-[#8D6435] dark:text-[#E6C299] underline underline-offset-2 hover:opacity-90 break-all"
                                onClick={(e) => e.stopPropagation()}
                            >
                                {href}
                            </a>
                            {trailing}
                        </React.Fragment>
                    );
                }
                return <React.Fragment key={i}>{part}</React.Fragment>;
            })}
        </span>
    );
}
